import { listingPage } from './listing-seo.js';

const isBlog = (route) => /^blog(?:___|$)/.test(String(route?.name || ''));

/** Undefined delegates to Nuxt; do not replace its hash/transition behavior. */
export function blogPaginationScrollPosition(to, from, savedPosition) {
  if (!isBlog(to) || !isBlog(from) || to.path !== from.path || to.hash)
    return undefined;
  const next = listingPage(to.query?.page);
  const previous = listingPage(from.query?.page);
  if (!next.valid || !previous.valid || next.page === previous.page)
    return undefined;
  return savedPosition ?? { left: 0, top: 0, behavior: 'instant' };
}

/** Page 1 is the collection URL; keep unrelated query values and URL anchors. */
export function canonicalBlogFirstPage(route) {
  if (route.query?.page !== '1') return null;
  const query = { ...route.query };
  delete query.page;
  return { path: route.path, query, hash: route.hash };
}

/** Matches the rendered page/category, ignoring unrelated attribution queries. */
export function blogPaginationKey(query = {}) {
  const category = Array.isArray(query.category)
    ? query.category[0]
    : query.category;
  return JSON.stringify([
    listingPage(query.page).page,
    category == null ? '' : String(category)
  ]);
}
